// extracted by mini-css-extract-plugin
export var createdDate = "_jt-1";
export var divider = "_jt-2";
export var headerDivider = "_jt-3";
export var messagesCard = "_jt-0";
export var messagesContainer = "_jt-6";
export var messagesContainerWrapper = "_jt-4";
export var showLeftPanelButton = "_jt-8";
export var topButtons = "_jt-7";
export var withPadding = "_jt-5";